import React, { useRef, useEffect } from 'react';

export const useTextToSpeech = (text: string | null, depend?: any) => {
  const speechRef = useRef<any>(null);

  useEffect(() => {
    if (text && depend) {
      speechRef.current = new SpeechSynthesisUtterance(text);
      speechRef.current.rate = 1; // 正常语速是1
      speechRef.current.volume = 1; // 音量范围 0 到 1
      speechRef.current.lang = 'zh-CN'; // 中文

      // 开始播报
      window.speechSynthesis?.speak &&
        window.speechSynthesis?.speak(speechRef.current);
    }
    return () => {
      window.speechSynthesis?.cancel && window.speechSynthesis?.cancel();
    };
  }, [text, depend]);
};
